import { useCallback, useState } from 'react';
import type { PmeLifeRow } from '../../components/pme/proposal.mock';
import { isPmeLifeIncomplete } from '../../components/pme/utils/pme-life-status.util';

/**
 * Trava de vidas sem nome e/ou CPF da proposta PME.
 *
 * `guard()` devolve `true` quando há vida incompleta e, nesse caso, preenche as
 * listas que abrem o `PmeIncompleteLivesDialog` (`dialogProps`). A REGRA mora no
 * `pme-life-status.util`, compartilhada com a bolinha amarela da coluna STATUS.
 *
 * Vale no Confirmar do Resumo — último ponto em que as vidas ainda podem ser
 * corrigidas — e de novo na Assinatura Digital, onde o documento nasce.
 */
export function usePmeIncompleteLivesGuard(lives: PmeLifeRow[]) {
  const [livesWithoutCpf, setLivesWithoutCpf] = useState<PmeLifeRow[]>([]);
  const [livesWithoutName, setLivesWithoutName] = useState<PmeLifeRow[]>([]);

  const guard = useCallback(() => {
    if (!lives.some(isPmeLifeIncomplete)) return false;
    setLivesWithoutCpf(lives.filter(life => !life.cpf?.trim()));
    setLivesWithoutName(lives.filter(life => !life.name?.trim()));
    return true;
  }, [lives]);

  const onDismiss = useCallback(() => {
    setLivesWithoutCpf([]);
    setLivesWithoutName([]);
  }, []);

  return {
    guard,
    dialogProps: { lives, livesWithoutCpf, livesWithoutName, onDismiss },
  };
}
